/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Cmp_Multica_Th4Inputs */

const en_mk_cmp_multica_th4 = /** @type {(inputs: Mk_Cmp_Multica_Th4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Relies on Slack, Lark, DingTalk or Telegram outside the product.`)
};

const id_mk_cmp_multica_th4 = /** @type {(inputs: Mk_Cmp_Multica_Th4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mengandalkan Slack, Lark, DingTalk, atau Telegram di luar produk.`)
};

/**
* | output |
* | --- |
* | "Relies on Slack, Lark, DingTalk or Telegram outside the product." |
*
* @param {Mk_Cmp_Multica_Th4Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_cmp_multica_th4 = /** @type {((inputs?: Mk_Cmp_Multica_Th4Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Cmp_Multica_Th4Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_cmp_multica_th4(inputs)
	return en_mk_cmp_multica_th4(inputs)
});